import { getPaymentStatus } from '../../../services/billingPayments';
import { TThunkAction } from '../../../types/thunk';
import { loadPublishTerms } from '../../../redux/reducers';
import { EPaymentStatus } from '../../../types/reducers/depositAccount';
import { updateDepositAccountRecommendedPackagePaymentStatus } from '../../../actions/depositAccount';
import { selectMainPaymentProvider } from '../../../selectors/paymentProviders';

export const checkPaymentStatus =
  (): TThunkAction =>
  async (dispatch, getState, { httpApi }) => {
    const state = getState();
    const {
      depositAccount: { paymentToken: paymentId },
    } = state;
    const provider = selectMainPaymentProvider(state)!;

    const { status } = await getPaymentStatus({ httpApi, paymentId: paymentId!, provider });

    dispatch(updateDepositAccountRecommendedPackagePaymentStatus(status));

    if (status === EPaymentStatus.Success) {
      dispatch(loadPublishTerms());
    }
  };
